import React, { useState } from "react";
import { FormButton, FormContainer, FormInput } from "./NewsletterForms.styled";

const NewsletterForm = () => {
  const [email, setEmail] = useState("");

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Lidar com o envio do formulário aqui, por exemplo, enviar o e-mail para o seu endereço de e-mail
    console.log("E-mail enviado:", email);
    setEmail(""); // Limpar o campo de entrada após o envio
  };

  return (
    <FormContainer>
      <p>Inscreva-se em nossa newsletter:</p>
      <form onSubmit={handleSubmit}>
        <FormInput
          type="email"
          value={email}
          onChange={handleEmailChange}
          placeholder="Seu e-mail"
          required
        />
        <FormButton type="submit">Inscrever</FormButton>
      </form>
    </FormContainer>
  );
};

export default NewsletterForm;
